module.exports = "https://cache-nest.services.handy.com/packs/media/src/assets/images/bg-f6d0e8bc2d752545b1d3365caf354ece.jpeg";